import { css } from 'linaria';
import { useTranslation } from 'next-i18next';
import { breakpointSmallHandset } from 'common/constants';
import { breakpointLargeHandset } from 'common/constants';
import { breakpointLargeTablet } from 'common/constants';
import { FilterMenu } from 'components/list-filter-menu/list-filter-menu';
import { ListSort } from 'components/list-sort/list-sort';
export const myListHeaderStyle = "m1nf84in";
export const MyListHeader = ({
  subset,
  filter,
  title,
  sortOrder,
  handleNewest,
  handleOldest
}) => {
  const {
    t
  } = useTranslation();
  const translatedHeaders = {
    unread: t('headers:my-list', 'My List'),
    archive: t('headers:archive', 'Archive'),
    favorites: t('headers:favorites', 'Favorites'),
    highlights: t('headers:highlights', 'Highlights'),
    articles: t('headers:articles', 'Articles'),
    videos: t('headers:videos', 'Videos'),
    tags: t('headers:tags', 'Tags')
  };
  return subset ? <header className={myListHeaderStyle}>
      <h1 className="pageTitle" data-cy="page-title">
        {translatedHeaders[title]}
      </h1>
      <FilterMenu subset={subset} filter={filter} />
      {subset !== 'tag-page' ? <ListSort sortOrder={sortOrder} handleNewest={handleNewest} handleOldest={handleOldest} /> : null}
    </header> : null;
};

require("./my-list-header.linaria.module.css!=!../../../node_modules/linaria/lib/outputCssLoader.js?cacheProvider=!./my-list-header.js");